import { render, staticRenderFns } from "./AttachProfitPriceField.vue?vue&type=template&id=d0aa7b3a"
import script from "./AttachProfitPriceField.vue?vue&type=script&lang=js"
export * from "./AttachProfitPriceField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports